import React from 'react';
import PropTypes from "prop-types";
import { makeStyles } from '@mui/styles';
import { InputLabel, MenuItem, FormControl, Select } from '@mui/material';
import { FormattedMessage,injectIntl } from 'react-intl';
import OutlinedInput from '@mui/material/OutlinedInput';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 120,
    fullWidth: true,
    display: 'flex',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));


function SimpleSelect(props) {

  const { label, options, stateName, changeSelect,changeSelectDirect, selected, required, disabled, customLabelSearch = "" } = props;

  const classes = useStyles();
  const [option, setOption] = React.useState(selected ? selected : 0);

  const inputLabel = React.useRef(null);
  const [labelwidth, setLabelWidth] = React.useState(0);

  React.useEffect(() => {
    //setLabelWidth(inputLabel.current.offsetWidth);
    setOption(selected ? selected : 0);
  }, [selected]);

  const handleChange = event => {
    setOption(event.target.value);
	console.error(event.target.value);
	if(changeSelect != null){
		changeSelect(stateName, event.target.value);
	  }
	  if(changeSelectDirect != null){
		changeSelectDirect(event.target.value);
	  }	  
  };

  const intl = props.intl;

  return (
    <div>
      <FormControl variant="outlined" className={classes.formControl}           
        disabled={disabled} fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">
          {label}
        </InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={option}
          onChange={handleChange}
          required={required}
          input={<OutlinedInput />}
        >
          <MenuItem key={0} value={0}>
            <em> {customLabelSearch && customLabelSearch.length > 0 ? customLabelSearch : (<FormattedMessage id="label.search" />)} </em>
          </MenuItem>

          {options && options.map(item => {
            return <MenuItem key={item.id} value={item.id}>{item.title ? item.title :  item.name}</MenuItem>
          })}
        </Select>
      </FormControl>
    </div>
  );
}
export default injectIntl(SimpleSelect);
SimpleSelect.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  stateName: PropTypes.string,
  changeSelect: PropTypes.func,
  selected: PropTypes.any,
  disabled : PropTypes.bool
};
